(ns ui.elevenlabs.generate-speech
  (:require [parts.replicant.command :as command]))

(defn render
  [{:keys [elevenlabs] :as state}]
  (let [command {:command/kind :command/elevenlabs-generate-speech
                 :command/data (select-keys elevenlabs
                                            [:text
                                             :voice-id
                                             :public-user-id])}]
    [:div {:class "flex flex-col items-center justify-center min-h-screen bg-gray-50 p-4"}
     ;; Container card
     [:div {:class "bg-white w-full max-w-2xl rounded shadow-md p-6"}
      ;; Title
      [:h2 {:class "text-2xl font-bold mb-4"}
       "Generate Speech"]
      ;; Label
      [:label {:class "block text-sm font-medium text-gray-700 mb-2"}
       "Enter your text:"]
      ;; Text area
      [:textarea
       {:class "w-full h-40 p-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        :placeholder "Type or paste your text here..."
        :on {:blur [[:store/assoc-in
                     [:elevenlabs
                      :text]
                     :event/target.value]]}}
       (:text elevenlabs)]
      ;; Generate button
      [:div {:class ["mt-4"]}
       [:button
        {:class ["bg-blue-500" "text-white" "px-4" "py-2" "rounded" "hover:bg-blue-600" "transition-colors" "duration-300"]
         :on {:click [[:data/command
                       command
                       {:on-success []}]]}}
        "Generate"]

       [:div
        [:label.block.font-medium.text-gray-900 {:for "voice" :class ["text-sm/6"]}
         "Voice"]
        [:div.mt-2.grid.grid-cols-1
         {:on {:click [[:ui/modal-open
                        :modals/elevenlabs-voice-list
                        {} ;; params map
                        ]]}}
         [:div#voice.col-start-1.row-start-1.w-full.appearance-none.rounded-md.bg-white.pl-3.pr-8.text-base.text-gray-900.outline.outline-1.-outline-offset-1.outline-gray-300
          {:class ["py-1.5"
                   "focus:outline"
                   "focus:outline-2"
                   "focus:-outline-offset-2"
                   "focus:outline-indigo-600"
                   "sm:text-sm/6"]}
          (or (:voice-name elevenlabs)
              "please select one")
          ]
         [:svg.pointer-events-none.col-start-1.row-start-1.mr-2.size-5.self-center.justify-self-end.text-gray-500
          {:viewBox "0 0 16 16"
           :fill "currentColor"
           :aria-hidden "true"
           :data-slot "icon"
           :class ["sm:size-4"]}
          [:path
           {:fill-rule "evenodd"
            :d
            "M4.22 6.22a.75.75 0 0 1 1.06 0L8 8.94l2.72-2.72a.75.75 0 1 1 1.06 1.06l-3.25 3.25a.75.75 0 0 1-1.06 0L4.22 7.28a.75.75 0 0 1 0-1.06Z"
            :clip-rule "evenodd"}]]]]

       (when-let [command-result (command/get-latest-result state
                                                            command)]
         [:audio {:controls "", :src (:url command-result)}]
         )
       ]]
     ]))

(def modal
  {:modal-id :modals/elevenlabs-generate-speech
   :on-load (fn [_state]
              #_[[:data/query query]])
   :render #'render})
